// @etp/auth-shared: paquete compartido worker↔dashboard (ADR 0002).
import { orgAc, orgRoles } from "@etp/auth-shared";
import { magicLinkClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/**
 * Cliente de Better Auth para el Dashboard.
 * Se conecta al Worker API usando la URL de entorno.
 * Sesión por cookie (SameSite=Lax): dashboard y API comparten site
 * (localhost / *.tagliapietra.ar), los fetch propios van con
 * credentials: "include".
 *
 * Plano tenant:  organizationClient con orgAc/orgRoles (de @etp/auth-shared).
 * Plano plataforma: NO usa adminClient — custom sobre platformMembership (handoff §1.3).
 *                   Ver src/lib/platform.ts para canPlatformDo y platformFetch.
 */
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:6787",
  plugins: [
    organizationClient({ ac: orgAc, roles: orgRoles, dynamicAccessControl: { enabled: true } }),
    magicLinkClient(),
  ],
});

export const { signIn, signOut, useSession } = authClient;
